import { createContext, useContext } from 'react'

export const StatusReportItemSupplementalContentContext = createContext({
  getItemSupplementalData: () => null,
  isLoading: false
})

export const useStatusReportItemSupplementalContentContext = () => useContext(StatusReportItemSupplementalContentContext)
